import { render, staticRenderFns } from "./GF.vue?vue&type=template&id=1aa79820&scoped=true"
import script from "./GF.vue?vue&type=script&lang=js"
export * from "./GF.vue?vue&type=script&lang=js"
import style0 from "./GF.vue?vue&type=style&index=0&id=1aa79820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa79820",
  null
  
)

export default component.exports